// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1vi3e","footer":"ModalFilter_footer__JppbD"};